const initialState = {
  totals: 0,
  record_type: null,
  current: "",
  loading: false,
  data: [],
  options: {},
  show_data: {},
  api_call_time: 0,
  alsoIncomeFilters: {
    page: 1,
    perPage: 50,
    filters: {
      date: ["", ""],
      arrival_date: ["", ""],
      status: undefined,
      user_id: undefined,
      close_date: ["", ""],
      earned: "",
      product: undefined,
      order_number: "",
      supplier_invoice_number: "",
      also_no: "",
      supplier_code: "",
      add_to: undefined,
    },
    filterString: "",
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "STOP_LOADING_CUSTOM":
      return {
        ...state,
        loading: false,
      };
    case "LOADING_CUSTOM":
      return {
        ...state,
        loading: true,
        data: [],
        show_data: {},
      };
    case "ONLY_LOADING_CUSTOM":
      return {
        ...state,
        loading: true,
      };
    case "LOADING_ONLY_CUSTOM":
      return {
        ...state,
        loading: true,
      };
    case "SET_OPTIONS":
      return {
        ...state,
        options: action.payload,
      };
    case "GET_CUSTOMS":
      return {
        ...state,
        api_call_time: action.payload.api_call_time || Date.now(),
        data: action.payload.data,
        totals: action.payload.totals || 0,
        current: action.payload.current || "",
        loading: false,
        show_data: action.payload.show_data || {},
      };
    case "GET_CUSTOM":
      return {
        ...state,
        show_data: action.payload,
        loading: false,
      };
    case "POST_CUSTOM":
      let updateData = [...state.data];
      updateData.unshift(action.payload);
      return {
        ...state,
        data: updateData,
        totals: state.totals + 1,
      };
    case "UPDATE_CUSTOM":
      let getData = [...state.data];
      console.log(action.payload);
      const updateElementId = (element) => element.id === action.payload.id;
      const findIndex = getData.findIndex(updateElementId);
      getData[findIndex] = action.payload;
      return {
        ...state,
        data: getData,
      };
    case "REMOVE_CUSTOM":
      return {
        ...state,
        data: [...state.data].filter((e) => e.id !== action.payload),
        loading: false,
        totals: state.totals - 1,
      };
    case "SET_VALUES":
      return {
        ...state,
        ...action.payload,
      };
    case "SET_ALSO_INCOME_FILTERS":
      return {
        ...state,
        alsoIncomeFilters: {
          ...state.alsoIncomeFilters,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
